import { render, staticRenderFns } from "./BulmaField.vue?vue&type=template&id=e718332c&scoped=true&"
import script from "./BulmaField.vue?vue&type=script&lang=ts&"
export * from "./BulmaField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e718332c",
  null
  
)

export default component.exports